export default __webpack_public_path__ + "static/media/2c.a9fb7ee6.png";